import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n.js";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import vco from "v-click-outside";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { setInteractionMode } from "vee-validate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import "@/design/index.scss";

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(vco);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("DatePicker", DatePicker);
Vue.component("Multiselect", Multiselect);

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "This field is required",
});

extend("positive", {
  validate: (value) => {
    return value >= 0;
  },
  message: "can't be negative",
});

extend("email", {
  ...email,
  message: "Invalid email",
});

extend("min", {
  validate(value, args) {
    return value.length >= args.length;
  },
  params: ["length"],
  message: (fieldName, placeholders) => {
    return `must be at least ${placeholders.length} characters long`;
  },
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Password confirmation does not match",
});

extend("minmax", {
  validate(value, { min, max }) {
    return parseInt(value, 10) >= min && parseInt(value, 10) <= max;
  },
  params: ["min", "max"],
  message: (fieldName, placeholders) => {
    return `must be between ${placeholders.min} and  ${placeholders.max}`;
  },
});

extend("greater", {
  params: ["target"],
  validate(value, { target }) {
    if (!target) return true;
    return parseFloat(value) > parseFloat(target);
  },
  message: "Price must not be less than discount",
});

extend("minimum", {
  validate(value, { target }) {
    return parseInt(value) >= parseInt(target);
  },
  params: ["target"],
  message: (fieldName, placeholders) => {
    return `cannot be less than ${placeholders.target}`;
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  fallbackLocale: "en",
  render: (h) => h(App),
}).$mount("#app");
